import { z } from 'zod'

import { UserCurrency } from '@/types/common'

export const BillingPackageIdZ = z.number().brand<'BillingPackageId'>()

export type BillingPackageId = z.infer<typeof BillingPackageIdZ>

// eslint-disable-next-line no-restricted-syntax
export enum BillingType {
	CreditCard = 'credit_card',
	MonthlyCredit = 'monthly_credit',
}

export const BillingTypeZ = z.enum(BillingType)

// eslint-disable-next-line no-restricted-syntax
export enum PackageStatus {
	ActiveSell = 'active_sell',
	Draft = 'draft',
	Pending = 'pending',
	Scheduled = 'scheduled',
	StopSell = 'stop_sell',
}

export const PackageStatusZ = z.enum(PackageStatus)

// eslint-disable-next-line no-restricted-syntax
export enum FeatureScope {
	Free = 'FREE',
	TravelOnly = 'TRAVEL_ONLY',
	TravelExpense = 'TRAVEL_EXPENSE',
}

export const FeatureScopeZ = z.enum(FeatureScope)

// eslint-disable-next-line no-restricted-syntax
export enum TripContentAllowance {
	Allowed = 'allowed',
	Default = 'default',
	NotAllowed = 'not_allowed',
}

export const TripContentAllowanceZ = z.enum(TripContentAllowance)

// TODO: Add PricingModel schema
export const BillingPackageZ = z.object({
	id: BillingPackageIdZ,
	name: z.string(),
	comments: z.string().nullable(),
	start_date: z.string().nullable(),
	previous_package_id: z.number().nullable(),
	status: PackageStatusZ,
	original_package_id: z.number().nullable(),
	feature_scope: FeatureScopeZ,
	stop_sell_date: z.string().nullable(),
	replaced_by_id: z.number().nullable(),
	pricing_models: z.array(z.unknown()), // PricingModel[]
	migrate_clients: z.boolean().nullable(),
})

export type BillingPackage = z.infer<typeof BillingPackageZ>

export const GetBillingPackagesResponseZ = z.array(BillingPackageZ)

// eslint-disable-next-line no-restricted-syntax
export enum PaymentMethodType {
	CreditCard = 'creditCard',
	VPA = 'vpa',
}

export const SyntheticPaymentMethodIdZ = z.templateLiteral([z.number(), '_', z.enum(PaymentMethodType)])
export type SyntheticPaymentMethodId = z.infer<typeof SyntheticPaymentMethodIdZ>

export interface Money {
	amount: string
	currency: UserCurrency
}

export interface BillingCost extends Money {
	billing_date: string | null
}
